import { Link } from 'react-router-dom';

import { articlePath } from '../utils/articlePath';
import { EXTERNAL_URL } from './ArticleLinkField';

/** The address a link item leads to, or null for an ordinary article. */
export function externalUrlOf(article) {
  const url = article?.external_url;
  return url && EXTERNAL_URL.test(url) ? url : null;
}

/**
 * A link to an article or news item wherever one is listed. A link item
 * (`external_url`) goes straight to its address, for everyone - clicking it
 * in a list is meant to open the other site. Its own page, with the address
 * and the edit button, stays reachable through the item's edit pencil.
 */
function ArticleLink({ article, children, ...rest }) {
  const url = externalUrlOf(article);

  if (url) {
    return (
      <a href={url} rel="noopener noreferrer" {...rest}>
        {children}
      </a>
    );
  }

  return (
    <Link to={articlePath(article)} {...rest}>
      {children}
    </Link>
  );
}

export default ArticleLink;
